import { GALLERY_COLLECTION_PAGE_ACTION, COMMON_CONTENT_ACTION, GALLERY_COLLECTION_PAGE_LOADER } from "../type"
 
const initialState ={
    loader : false,
    data :{},
    common_data :{}
}
 
const GalleryCollectionReducer  = (state = initialState, action) => {
    switch (action.type){
        case GALLERY_COLLECTION_PAGE_LOADER:{
            return {...state,loader : action.loader};
        }
        case GALLERY_COLLECTION_PAGE_ACTION :{
            return {...state, data: action.data};
        }
        case COMMON_CONTENT_ACTION :{
             return {...state, common_data: action.data};
        }
        default :{
            return state
        }
    }
}
 
export default GalleryCollectionReducer;